import { createContext } from "react";

const RumContext = createContext({
	componentBreadCrumbs: "root",
	component: "root",
});

export default RumContext;
